import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { AccountsPage } from './pages/AccountsPage';
import { TransactionsPage } from './pages/TransactionsPage';
import { CreditCardPage } from './pages/CreditCardPage';
import { RecurringExpensesPage } from './pages/RecurringExpensesPage';
import { LoansPage } from './pages/LoansPage';
import { BudgetPage } from './pages/BudgetPage';
import { SavingsGoalsPage } from './pages/SavingsGoalsPage';
import { SettingsPage } from './pages/SettingsPage';
import { MorePage } from './pages/MorePage';
import { LandingPage } from './pages/LandingPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';
import { SupportPage } from './pages/SupportPage';
import { AssistantPage } from './pages/AssistantPage';
import { AdminAiUsagePage } from './pages/AdminAiUsagePage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/registro" element={<RegisterPage />} />
      <Route path="/verificar-correo" element={<VerifyEmailPage />} />
      <Route path="/restablecer" element={<ResetPasswordPage />} />
      <Route path="/privacidad" element={<PrivacyPage />} />
      <Route path="/soporte" element={<SupportPage />} />

      {/* Privadas */}
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/panorama" element={<DashboardPage />} />
          <Route path="/asistente" element={<AssistantPage />} />
          <Route path="/admin/ia" element={<AdminAiUsagePage />} />
          <Route path="/cuentas" element={<AccountsPage />} />
          <Route path="/transacciones" element={<TransactionsPage />} />
          <Route path="/tarjeta" element={<CreditCardPage />} />
          <Route path="/gastos-fijos" element={<RecurringExpensesPage />} />
          <Route path="/mas" element={<MorePage />} />
          <Route path="/deudas" element={<LoansPage />} />
          <Route path="/presupuesto" element={<BudgetPage />} />
          <Route path="/metas" element={<SavingsGoalsPage />} />
          <Route path="/ajustes" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/panorama" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
